import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../models/userDetails';
import axios from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';
import { composeParamsString } from '../../utilities/CommonHelper';

interface EmployeeData {
    id: number;
    type: string;
    employeeName: string;
    employeeEmail: string;
    employeeId: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    role: string;
    accessReason: string;
    reminderEmailCount: number;
    requestStatus: string;
    approvalRejects: any[];
  }
  
  interface EmployeeResponse {
    data: EmployeeData[] | null;
    error: null | string;
    loading: boolean;
  }

  const initialState: EmployeeResponse = {
    data: null,
    error: null,
    loading: false,  
};

export const fetchRmPendingRequest:any = createAsyncThunk(
  'request/fetchRmPendingRequest',
  async (params:{
    page?: number;
    size?: number;
    sort?: string[];
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`user/request/pendingRequestAtRm?${paramStrings}`,axiosConfig);
      console.log('request/pendingRequestAtRm',response);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const approveRejectByRM:any = createAsyncThunk(
    'user/request/approveRejectByRM',
    async (values:any,{ rejectWithValue }) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
            // 'loggedInUser': 'shalini.r@indegene.com'
          },
          withCredentials: true
        };
        // Simulate an API call, replace with your actual API request
        const response = await axios.post(`user/request/approveRequest`,values,axiosConfig);
        console.log('user/request/approveRequest',response);
        if (response.data.status!=="OK") {
          const errorData = await response.data.error
          return rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

const rmPendingRequestSlice:any = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // setSuccessFactorUserData: (state, action: PayloadAction<EmployeeResponse['data']>) => {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.error = null;
    // },
    fetchRmPendingRequest_Request: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRmPendingRequest_Success: (state, action: PayloadAction<EmployeeResponse['data']>) => {
         
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchRmPendingRequest_Failure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRmPendingRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRmPendingRequest.fulfilled, (state, action) => {
         
        state.data = action.payload.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchRmPendingRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(approveRejectByRM.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveRejectByRM.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(approveRejectByRM.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const {fetchRmPendingRequest_Request, fetchRmPendingRequest_Success, fetchRmPendingRequest_Failure } = rmPendingRequestSlice.actions;

export default rmPendingRequestSlice.reducer;